import styled from 'styled-components/macro';
import chevron from 'assets/icons/chevron-down.svg';

export const AddressItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 4px 6px 4px 8px;
  background-color: #f2f5f8;
  border-radius: 4px;
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const ItemWrapper = styled.div<{
  isClickable: boolean;
}>`
  display: flex;
  gap: 8px;
  color: #1f2939;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};

  :hover {
    color: ${(props) => (props.isClickable ? '#3e78e9' : '#1f2939')};
  }
`;

export const ChevronIcon = styled.img.attrs({
  src: chevron,
})`
  height: 16px;
  width: 16px;
`;

export const EmptyIcon = styled.div`
  height: 16px;
  width: 16px;
`;
